/**
 * HLF Collection Product Card — Section JavaScript
 * Extracted from hlf-collection-product-card.liquid for browser cacheability.
 * Reads section ID from data-section-id attribute on the section element.
 */
(function () {
  'use strict';

  // Find all HLF sections on the page and initialize each
  document.querySelectorAll('[data-section-id]').forEach(initSection);

  function initSection(section) {
    if (section._hlfInitialized) return;
    section._hlfInitialized = true;

    /* ============================================================
       LAYOUT SWITCHER
    ============================================================ */
    const container = section.querySelector('.hlf-products-container');
    const inner = section.querySelector('.hlf-products-inner');
    const toggleBtns = section.querySelectorAll('.hlf-layout-toggle__btn');

    if (!container || !inner) return;

    function updateLayout() {
      const isMobile = window.innerWidth <= 640;
      const layout = isMobile ? container.dataset.layoutMobile : container.dataset.layoutDesktop;

      if (layout === 'slider') {
        if (!container._hlfSliderApi) {
          container._hlfSliderApi = initSlider(container, inner, section);
        }
      } else {
        if (container._hlfSliderApi) {
          container._hlfSliderApi.destroy();
          container._hlfSliderApi = null;
        }
      }
    }

    window.addEventListener('resize', () => {
      updateLayout();
    });
    updateLayout();

    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const newLayout = btn.dataset.layout;

        // Manually override current responsive layout for this session
        const isMobile = window.innerWidth <= 640;
        if (isMobile) {
          container.dataset.layoutMobile = newLayout;
        } else {
          container.dataset.layoutDesktop = newLayout;
        }

        toggleBtns.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        updateLayout();
      });
    });

    /* ============================================================
       WISHLIST TOGGLE
    ============================================================ */
    section.addEventListener('click', function (e) {
      const wishBtn = e.target.closest('[data-wishlist-btn]');
      if (wishBtn) {
        e.preventDefault();
        wishBtn.classList.toggle('is-wishlisted');
        const productId = wishBtn.dataset.productId;
        // Dispatch custom event for integration with wishlist apps
        document.dispatchEvent(new CustomEvent('hlf:wishlist:toggle', {
          detail: { productId, isWishlisted: wishBtn.classList.contains('is-wishlisted') }
        }));
      }
    });

    /* ============================================================
       ADD TO CART
    ============================================================ */
    section.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('is-loading');
      btn.disabled = true;

      // Mirror Dawn's product-form.js exactly
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(btn);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Cart Error:', response.description);
            return;
          } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // CRITICAL: publish BEFORE renderContents — matches Dawn's native ordering
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });

          cart.renderContents(response);

          // Dispatch cart:update for the HLF custom header cart count
          if (response.sections) {
            fetch(`${routes.cart_url}.js`)
              .then(res => res.json())
              .then(cartData => {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  detail: { data: { itemCount: cartData.item_count } }
                }));
              });
          }

          // Visual feedback
          const originalText = btn.querySelector('.hlf-btn-text');
          if (originalText) {
            const orig = originalText.textContent;
            originalText.textContent = '✓ Added!';
            setTimeout(() => { originalText.textContent = orig; }, 1800);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    });
  }

  /* ============================================================
     SLIDER ENGINE
  ============================================================ */
  function initSlider(container, track, section) {
    const prevBtn = container.querySelector('.hlf-slider-arrow--prev');
    const nextBtn = container.querySelector('.hlf-slider-arrow--next');
    const navContainer = container.querySelector('.hlf-slider-nav');
    const autoplay = container.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 3000;
    const loop = container.dataset.loop === 'true';

    let currentIndex = 0;
    let autoplayInterval = null;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let startTranslate = 0;

    const cards = track.querySelectorAll('.hlf-product-card');
    const totalCards = cards.length;

    /** Gap between slides (must match CSS flex gap). */
    function getGap() {
      const w = window.innerWidth;
      return w <= 640
        ? parseInt(getComputedStyle(section).getPropertyValue('--hlf-card-gap-mobile'), 10) || 12
        : parseInt(getComputedStyle(section).getPropertyValue('--hlf-card-gap-desktop'), 10) || 20;
    }

    /** One slide step = card width + gap (matches rendered flex items). */
    function getSlideWidth() {
      if (!cards.length) return 0;
      const gap = getGap();
      const cw = cards[0].getBoundingClientRect().width;
      return cw + gap;
    }

    /** Whole cards approx. fitting in viewport. */
    function getWholeVisibleCount() {
      const sw = getSlideWidth();
      if (sw <= 0) return 1;
      const gap = getGap();
      return Math.max(1, Math.floor((track.offsetWidth + gap) / sw));
    }

    function getMaxIndex() {
      return Math.max(0, totalCards - getWholeVisibleCount());
    }

    function goTo(index, animate = true) {
      const max = getMaxIndex();
      if (!loop) {
        index = Math.max(0, Math.min(index, max));
      } else {
        if (index < 0) index = max;
        if (index > max) index = 0;
      }
      currentIndex = index;
      const offset = currentIndex * getSlideWidth();
      track.style.transition = animate ? 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = `translateX(-${offset}px)`;
      updateArrows();
      updateDots();
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      const max = getMaxIndex();
      if (!loop) {
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex >= max;
      } else {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
      }
    }

    function buildDots() {
      if (!navContainer) return;
      navContainer.innerHTML = '';
      const max = getMaxIndex();
      for (let i = 0; i <= max; i++) {
        const dot = document.createElement('button');
        dot.className = 'hlf-slider-nav__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => goTo(i));
        navContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!navContainer) return;
      navContainer.querySelectorAll('.hlf-slider-nav__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    // Touch/Drag support
    track.addEventListener('mousedown', dragStart);
    track.addEventListener('touchstart', dragStart, { passive: true });
    window.addEventListener('mouseup', dragEnd);
    window.addEventListener('touchend', dragEnd);
    track.addEventListener('mousemove', dragMove);
    track.addEventListener('touchmove', dragMove, { passive: false });

    function dragStart(e) {
      isDragging = true;
      startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      startTranslate = currentIndex * getSlideWidth();
      track.style.transition = 'none';
    }

    function dragMove(e) {
      if (!isDragging) return;
      const x = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      const diff = startX - x;
      currentTranslate = startTranslate + diff;
      track.style.transform = `translateX(-${currentTranslate}px)`;
      if (e.type === 'touchmove') e.preventDefault();
    }

    function dragEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      const x = e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX;
      const diff = startX - x;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      } else {
        goTo(currentIndex);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(currentIndex - 1); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(currentIndex + 1); resetAutoplay(); });

    function startAutoplay() {
      if (!autoplay) return;
      autoplayInterval = setInterval(() => goTo(currentIndex + 1), autoplaySpeed);
    }

    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }

    function pauseOnHover() {
      container.addEventListener('mouseenter', () => clearInterval(autoplayInterval));
      container.addEventListener('mouseleave', startAutoplay);
    }

    window.addEventListener('resize', () => {
      goTo(Math.min(currentIndex, getMaxIndex()), false);
      buildDots();
      updateArrows();
    });

    function syncAfterLayout() {
      goTo(Math.min(currentIndex, getMaxIndex()), false);
      buildDots();
      updateArrows();
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(syncAfterLayout);
    });

    startAutoplay();
    pauseOnHover();

    return {
      destroy() {
        clearInterval(autoplayInterval);
        track.style.transform = '';
        track.style.transition = '';
      }
    };
  }
})();
